//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import _ from "js/underscore-mixins";

(function() {
  const curalate = angular.module('curalate');
  curalate.filter('prettyPrintSearchFilter', [
    'SearchFilterService',
    function(
            SearchFilterService,
        ) {
      const filterAliasesBySet = {};

      const addFilter = (newData) => {
        filterAliasesBySet[newData.setName] = {
          filterKeyAliases: angular.copy(newData.filterKeyAliases),
          filterOptionAliases: angular.copy(newData.filterOptionAliases),
        };
      };

      SearchFilterService.getAliasObservable().subscribe((setUpdate) => {
        if (setUpdate && setUpdate.setName) {
          addFilter(setUpdate);
        }
      });

      const prettyPrintFilter = function(value) {
        if (!value) {
          return '';
        }

        SearchFilterService.getAliasObservable().subscribe((newData) => {
          addFilter(newData);
        });

        const key = value.key;
        const option = value.option;
        const optionKey = _(option).safeGet('aliasKey') || option;
        const setName = value.setName;
        let prettyPrintedValue;
        if (option !== undefined) {
          prettyPrintedValue = filterAliasesBySet[setName] && filterAliasesBySet[setName].filterOptionAliases[`${key}:${optionKey}`] || option;
        } else {
          prettyPrintedValue = filterAliasesBySet[setName] && filterAliasesBySet[setName].filterKeyAliases[key] || key;
        }
        return prettyPrintedValue;
      };
      prettyPrintFilter.$stateful = true;
      return prettyPrintFilter;
    },
  ]);
})();
